var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.2647 37.0337C66.4868 36.2558 65.4395 35.8169 64.3423 35.8169C63.2452 35.8169 62.1979 36.2458 61.4199 37.0337L44.1349 54.229L38.5993 48.6535C37.0034 47.0577 34.3802 47.0377 32.7644 48.6236C31.1387 50.2095 31.1187 52.8327 32.7146 54.4684L41.1726 62.9863C41.9506 63.7642 42.9978 64.2031 44.1049 64.2031C45.2021 64.2031 46.2394 63.7742 47.0174 62.9962L67.2448 42.8885C68.8406 41.2927 68.8606 38.6695 67.2747 37.0537L67.2647 37.0337Z",
    fill: "#5BCDD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0702 30.5605C93.5468 24.606 89.9362 19.2599 85.3481 14.6619C80.7501 10.0738 75.404 6.4632 69.4494 3.93976C63.2855 1.32655 56.7425 0 50 0C22.4317 0.00997407 0 22.4417 0 50.01C0 77.5783 22.4317 100.01 50 100.01C77.5683 100.01 100 77.5783 100 50.01C100 43.2675 98.6834 36.7245 96.0702 30.5605ZM50 91.7415C26.9898 91.7415 8.2685 73.0201 8.2685 50.01C8.2685 26.9998 26.9898 8.27848 50 8.27848C73.0102 8.27848 91.7315 26.9998 91.7315 50.01C91.7315 73.0201 73.0102 91.7415 50 91.7415Z",
    fill: "#5BCDD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.ae376cee5a4458a4ce9c54d4c98b15cd.svg";
export { ForwardRef as ReactComponent };